import { Operation } from "./operation";
import { IOperation } from "../operation.interface";

export class DefaultOperation extends Operation implements IOperation {

    transactionType: "SyncUpOperationStepPrimary";

}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/operations/default-operation.ts